"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalWrapper = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const scrollbar_1 = require("../../../helpers/scrollbar");
const useFadeInOut_1 = require("../../../hooks/useFadeInOut");
const ModalWrapper = ({ open, className, onBackgroundClick, children, position = 'middle', onEscape, testing, }) => {
    const { display, animateIn } = (0, useFadeInOut_1.useFadeInOut)(open);
    (0, react_1.useEffect)(() => {
        // Add Overflow to document
        if (display) {
            (0, scrollbar_1.hideScroll)();
        }
        else {
            (0, scrollbar_1.showScroll)();
        }
        // Cleanup
        return () => {
            (0, scrollbar_1.showScroll)();
        };
    }, [display]);
    // Handle Escape Key to close
    (0, react_1.useEffect)(() => {
        let callback = null;
        if (onEscape && open) {
            callback = (e) => {
                if (e.key === 'Escape') {
                    onEscape(e);
                }
            };
            document.addEventListener('keydown', callback);
        }
        return () => {
            if (callback) {
                document.removeEventListener('keydown', callback);
            }
        };
    }, [onEscape, open]);
    const bgClickHandler = onBackgroundClick &&
        ((e) => {
            e.stopPropagation();
            onBackgroundClick(e);
        });
    const modalRoot = document.getElementById('modal-root');
    if (!display)
        return null;
    const modal = (react_1.default.createElement("div", { className: (0, classnames_1.default)('fixed top-0 left-0 z-50 flex h-full w-full flex-col items-center py-16 transition-opacity ', animateIn ? 'opacity-100' : 'opacity-0', {
            'justify-center': position === 'middle',
            'justify-start': position === 'top',
            'justify-end': position === 'bottom',
        }, className), "data-testid": testing ? 'modal-wrapper' : undefined },
        react_1.default.createElement("button", { "data-testid": testing ? 'modal-background' : undefined, tabIndex: -1, className: "absolute left-0 top-0 -z-10 h-full w-full bg-black bg-opacity-20 focus:outline-none", onClick: bgClickHandler }),
        children));
    return modalRoot ? (0, react_dom_1.createPortal)(modal, modalRoot) : modal;
};
exports.ModalWrapper = ModalWrapper;
